<div ng-show="$ctrl.showModalAplicacao" class="modal-header">
  <button
    type="button"
    class="close"
    ng-click="$close()"
  >
    &times;
  </button>
  <h4 class="modal-title">Vincular aplicação</h4>
</div>
<div ng-show="$ctrl.showModalAplicacao" class="modal-body modal-aplicacoes" ng-class="{ 'modal-expande': isDropdownOpen }">
  <div class="row">
    <div class="col-xs-12">
      <div class="form-group">
        <label>Aplicação</label>
        <ui-select id="dropdown-aplicacoes" ng-model="$ctrl.aplicacao" theme="bootstrap">
          <ui-select-match allow-clear="true" placeholder="Selecione" ng-click="$ctrl.onDropdownOpen()">
            {{$select.selected.gleba.descricao | capitalize}}
            ({{$select.selected.area | number:2}}ha)
            {{$select.selected.grupo_insumos | orderBy:'descricao' | getTextItems | capitalize}}
            {{$select.selected.dt_ini | date:'dd/MM/yy'}}
            <span ng-show="$select.selected.dt_ini != $select.selected.dt_fim" style="display: inline;">à {{$select.selected.dt_fim | date:'dd/MM/yy'}}</span>
          </ui-select-match>
          <ui-select-choices class="dropdown-options" repeat="application in $ctrl.applications | filter: $select.search" ng-click="$ctrl.onDropdownClose()">
            <span class="form-group">
              {{::application.gleba.descricao | capitalize}}
              ({{::application.area | number:2}}ha)
              {{::application.grupo_insumos | orderBy:'descricao' | getTextItems | capitalize}}
              {{::application.dt_ini | date:'dd/MM/yy'}}
              <span ng-show="application.dt_ini != application.dt_fim">à {{::application.dt_fim | date:'dd/MM/yy'}}</span>
            </span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="form-group">
        <button type="button"
          class="btn btn-success pull-right"
          ng-click="$ctrl.vinculaAplicacao()"
          ng-disabled="!$ctrl.aplicacao"
        >
          Salvar
          <i class="fa fa-check"></i>
        </button>
      </div>
    </div>
  </div>
</div>
  